import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { VerticalListArrows } from '@lean-body/components/molecules/vertical_list_arrows';
import { LessonRankingCard } from '@lean-body/components/molecules/lesson_ranking_card';
import { separateArrayBySpecifiedNumber } from '@lean-body/src/util';
import { LIST_ITEM_MARGIN_RIGHT } from '../pages/main_home';
const RANKING_VERTICAL_COUNT = 3;
export const LessonRanking = ({ rankings, classObject, itemsPadding, addFavoriteLesson, unFavoriteLesson, itemSize, isBig, }) => {
    return (React.createElement(VerticalListArrows, { itemMarginRight: LIST_ITEM_MARGIN_RIGHT, classObject: [styles.container, classObject], itemsPadding: itemsPadding, itemSize: itemSize, items: separateArrayBySpecifiedNumber(rankings, RANKING_VERTICAL_COUNT).map((rowRankingList) => (React.createElement("div", { className: css(styles.itemContainer) }, rowRankingList.map((v, i) => {
            return (React.createElement(LessonRankingCard, { ranking: v, classObject: styles.item, key: i, addFavoriteLesson: addFavoriteLesson, unFavoriteLesson: unFavoriteLesson, isBig: isBig }));
        })))) }));
};
const styles = StyleSheet.create({
    container: {},
    itemContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'scroll',
        '::-webkit-scrollbar': {
            display: 'none',
        },
    },
    item: {
        marginBottom: 10,
        ':nth-of-type(3n)': {
            marginBottom: 0,
        },
    },
});
